// @ts-nocheck
import { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import DeleteButton from '../../../Layout/DeleteButton/DeleteButton';
import { XGInput } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import { preventBubbling } from '../../../../utils/eventHelper';
import { getPassengerFieldTypeLabel } from '../../../../utils/passengerFieldTypes';
import * as PropTypes from 'prop-types';
import './PassengerFieldLibraryTable.css';

const PINNED_SYSTEM_FIELD_TITLES = ['First Name', 'Last Name', 'Email Address'];

const PassengerFieldLibraryTable = ({
  passengerFields = [],
  handleOnEditField,
  handleOnDeleteField,
  headerAction = null,
  isSubmitting = false
}) => {
  const { t } = useTranslation(['settings', 'common', 'passengers']);
  const [searchValue, setSearchValue] = useState('');

  const filteredPassengerFields = useMemo(() => {
    const normalizedSearch = searchValue.trim().toLowerCase();

    return [...passengerFields]
      .filter((field) => {
        if (!normalizedSearch) {
          return true;
        }

        return field?.title?.toLowerCase().includes(normalizedSearch);
      })
      .sort((fieldA, fieldB) => {
        if (fieldA?.issystemfield !== fieldB?.issystemfield) {
          return fieldA?.issystemfield ? -1 : 1;
        }

        if (fieldA?.issystemfield) {
          const orderA = PINNED_SYSTEM_FIELD_TITLES.indexOf(
            fieldA?.title ?? ''
          );
          const orderB = PINNED_SYSTEM_FIELD_TITLES.indexOf(
            fieldB?.title ?? ''
          );
          const pinnedA =
            orderA === -1 ? PINNED_SYSTEM_FIELD_TITLES.length : orderA;
          const pinnedB =
            orderB === -1 ? PINNED_SYSTEM_FIELD_TITLES.length : orderB;
          if (pinnedA !== pinnedB) return pinnedA - pinnedB;
        }

        return (fieldA?.title ?? '').localeCompare(fieldB?.title ?? '');
      });
  }, [passengerFields, searchValue]);

  const getUsedInRoundsLabel = (field) => {
    if (field?.isinternal) {
      return t('internalFields');
    }

    if (field?.usedinrounds?.length) {
      return field.usedinrounds.join(', ');
    }

    return t('unassigned');
  };

  return (
    <Box className='passenger-field-library'>
      <Box className='passenger-field-library__search-row'>
        <Box className='passenger-field-library__actions'>
          <XGInput
            id='passenger-field-library-search'
            label={null}
            name='passenger-field-library-search'
            placeholder={t('searchFieldLibrary')}
            type='text'
            value={searchValue}
            onChange={(event) => setSearchValue(event?.target?.value ?? '')}
          />
        </Box>
        {headerAction ? (
          <Box className='passenger-field-library__search-action'>
            {headerAction}
          </Box>
        ) : null}
      </Box>

      <Box className='passenger-field-library__table-wrapper'>
        <table className='passenger-field-library__table'>
          <thead>
            <tr>
              <th>{t('fieldName')}</th>
              <th>{t('type')}</th>
              <th>{t('usedInRounds')}</th>
              <th className='passenger-field-library__actions-column' />
            </tr>
          </thead>
          <tbody>
            {filteredPassengerFields.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className='passenger-field-library__empty-state'
                >
                  {t('noPassengerFieldsFound')}
                </td>
              </tr>
            ) : (
              filteredPassengerFields.map((field) => (
                <tr
                  key={
                    field?.libraryrowid ??
                    field?.passengerfieldid ??
                    field?.trippassengerfieldid ??
                    field?.title
                  }
                  className={
                    field?.issystemfield
                      ? 'passenger-field-library__row passenger-field-library__row--system'
                      : 'passenger-field-library__row'
                  }
                  onClick={() =>
                    !isSubmitting &&
                    !field?.issystemfield &&
                    field?.canedit !== false &&
                    field?.passengerfieldid &&
                    handleOnEditField(field?.passengerfieldid)
                  }
                >
                  <td>
                    <Box className='passenger-field-library__field-cell'>
                      <span>{field?.title}</span>
                    </Box>
                  </td>
                  <td>{getPassengerFieldTypeLabel(field?.fieldtype, t)}</td>
                  <td>{getUsedInRoundsLabel(field)}</td>
                  <td className='passenger-field-library__actions-cell'>
                    {!field?.issystemfield && field?.candelete !== false && (
                      <DeleteButton
                        disabled={isSubmitting}
                        onClick={(event) => {
                          preventBubbling(event);
                          handleOnDeleteField(field);
                        }}
                      />
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

PassengerFieldLibraryTable.propTypes = {
  passengerFields: PropTypes.array,
  handleOnEditField: PropTypes.func,
  handleOnDeleteField: PropTypes.func,
  headerAction: PropTypes.node,
  isSubmitting: PropTypes.bool
};

export default PassengerFieldLibraryTable;
